import { render, staticRenderFns } from "./ButtonDropdown.vue?vue&type=template&id=383d0544&scoped=true&"
import script from "./ButtonDropdown.vue?vue&type=script&lang=js&"
export * from "./ButtonDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDropdown.vue?vue&type=style&index=0&id=383d0544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d0544",
  null
  
)

export default component.exports